/* tslint:disable */
/* eslint-disable */
/**
 * Mailbox API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MailboxPlaceholderDTO
 */
export interface MailboxPlaceholderDTO {
    /**
     * 
     * @type {string}
     * @memberof MailboxPlaceholderDTO
     */
    Key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MailboxPlaceholderDTO
     */
    Label?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MailboxPlaceholderDTO
     */
    Group?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MailboxPlaceholderDTO
     */
    Sample?: string | null;
}

/**
 * Check if a given object implements the MailboxPlaceholderDTO interface.
 */
export function instanceOfMailboxPlaceholderDTO(value: object): value is MailboxPlaceholderDTO {
    return true;
}

export function MailboxPlaceholderDTOFromJSON(json: any): MailboxPlaceholderDTO {
    return MailboxPlaceholderDTOFromJSONTyped(json, false);
}

export function MailboxPlaceholderDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailboxPlaceholderDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'Key': json['Key'] == null ? undefined : json['Key'],
        'Label': json['Label'] == null ? undefined : json['Label'],
        'Group': json['Group'] == null ? undefined : json['Group'],
        'Sample': json['Sample'] == null ? undefined : json['Sample'],
    };
}

export function MailboxPlaceholderDTOToJSON(json: any): MailboxPlaceholderDTO {
    return MailboxPlaceholderDTOToJSONTyped(json, false);
}

export function MailboxPlaceholderDTOToJSONTyped(value?: MailboxPlaceholderDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Key': value['Key'],
        'Label': value['Label'],
        'Group': value['Group'],
        'Sample': value['Sample'],
    };
}

